import { Button, Card, CardActions, CardContent, CardHeader, colors, Modal, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Account } from 'services';
import useErrorCatcher from "utils/useErrorCatcher";
import { LoadingIndicator, ErrorMessage } from 'components';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    width: 700,
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  container: {
    marginTop: theme.spacing(3)
  },
  actions: {
    justifyContent: 'space-between'
  },
  saveButton: {
    color: theme.palette.white,
    backgroundColor: colors.red[600],
    '&:hover': {
      backgroundColor: colors.red[900]
    },
    float: "left"
  },
  label: {
    fontSize: 18
  },
  header: {
    fontWeight: 600
  },
  loading: {
    marginLeft: theme.spacing(3)
  }
}));
let mounted = false;

const CardInfo = props => {
  const { open, onClose, className, model, reload, ...rest } = props;

  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const runAsyncBlock = useErrorCatcher(error => setErrorMessage(error && error.message));

  useEffect(() => {
    mounted = true;
    return () => { mounted = false };
  }, [])

  useEffect(() => {
    if (mounted) {
      setErrorMessage("");
    }
  }, [open]);

  if (!open) {
    return null;
  }

  const handleDelete = () => {
    setLoading(true);
    runAsyncBlock(async () => {
      await Account.del_card(model.id);
    }).finally(() => {
      if (mounted) {
        setLoading(false);
        onClose();
        reload();
      }
    });
  }

  return (
    <Modal
      onClose={onClose}
      open={open}>
      <Card
        {...rest}
        className={clsx(classes.root, className)}>
        <form>
          <CardHeader title="Card Details" />
          <CardContent>
            <ErrorMessage message={errorMessage} />
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell className={classes.header}>Number</TableCell>
                  <TableCell>**** **** **** {model.extra1}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.header}>Expiry</TableCell>
                  <TableCell>{model.extra2}/{model.extra3}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.header}>Date Added</TableCell>
                  <TableCell>{moment(model.created_at).format("DD/MM/YYYY")}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </CardContent>
          <CardActions className={classes.actions}>
            <div>
              <Button className={classes.saveButton} onClick={handleDelete} variant="contained">
                Delete<LoadingIndicator className={classes.loading} active={loading} spinnerProps={{ size: 24 }} />
              </Button>
            </div>
            <Button onClick={onClose} variant="contained">Close</Button>
          </CardActions>
        </form>
      </Card>
    </Modal>
  );
};

CardInfo.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool
};

CardInfo.defaultProps = {
  open: false,
  onClose: () => { }
};

export default CardInfo;
